




import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {showNotification} from '@/services/notification-service';

@Component
export default class QuestionTimer extends Vue {

    @Prop({
        default: (): Date => new Date(),
    })
    protected endTime!: Date;

    @Prop({
        default: (): boolean => true,
    })
    protected fullLength!: boolean;

    @Prop({
        default: (): boolean => false,
    })
    protected notification!: boolean;

    protected timeLeft: number = -1;
    protected done: boolean = false;
    protected intervalId: number = 0;

    protected created() {
        this.startTimer();
    }

    protected startTimer() {
        if (this.endTime !== null) {
            this.done = false;
            this.updateTimeLeft();
            window.clearInterval(this.intervalId);
            this.intervalId = window.setInterval(this.onTick.bind(this), 1000);
        }
    }

    protected onTick() {
        if (this.done === false && this.timeLeft !== -1) {
            this.updateTimeLeft();
            if (this.timeLeft <= 0) {
                this.$emit('complete');
                this.timeLeft = -1;
                this.done = true;
                window.clearInterval(this.intervalId);
            }
        }
    }

    protected updateTimeLeft() {
        const millisLeft = this.endTime.getTime() - Date.now();
        this.timeLeft = millisLeft;
    }

    @Watch('endTime')
    protected onEndTimeChanged() {
        this.startTimer();
    }

    protected get displayTimeLeft() {
        if (this.timeLeft < 0) {
            return 'No time remaining';
        }

        const secondsTotal = Math.round(this.timeLeft / 1000);
        const minutesTotal = Math.floor(secondsTotal / 60);
        const secondsModulus = secondsTotal % 60;
        return this.fullLength ? `${minutesTotal} minutes and ${secondsModulus} seconds remaining until auto-submission.` : `${minutesTotal} min ${secondsModulus} sec`;
    }
}
